function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from '@shared/components/spzaComponent';
import { AppReviewItem } from '@shared/components/appReviewItem';
import { Constants } from '@shared/utils/constants';
import { RatingSummary } from '@shared/components/ratingSummary';
import { createDeepLinkPagination, createDefaultPagination, getAddReviewSectionDescription, getReviewCtaButtonText, launchTelemetry, getExternalRatingSummaries, findReviewsSources, getRatingSummaryByType } from '@shared/utils/reviewsUtils';
import { ReviewsDropDowns } from '@shared/components/reviewsDropDowns';
import { DefaultButton, mergeStyleSets, Spinner, Stack, ScreenWidthMinXLarge, ScreenWidthMinXXLarge } from '@fluentui/react';
import { NoReviewsToShow } from '@shared/components/noReviewsToShow';
import { getWindow } from '@shared/services/window';
import { logger } from '@src/logger';
import { isSignedInChanged } from '@shared/utils/appUtils';
import { NeutralColors, CommunicationColors } from '@fluentui/theme';
import { ExternalRatingSummaries } from '@shared/containers/externalRatingSummaries';
import { shouldShowUserTerms } from '@shared/utils/detailUtils';
import { UserTerms } from '@appsource/components/userTerms';
import classNames from 'classnames';
const DEFAULT_STICKY_HEIGHT = 64;
const DEFAULT_MENU_HEIGHT = 54;
const SCROLL_TO_REVIEW_TOP_MARGIN = 16;
const contentStyles = mergeStyleSets({
    reviewsTopBar: [
        'reviewsTopBar',
        {
            marginBottom: 24
        }
    ],
    reviewsDateLabel: {
        color: NeutralColors.gray130
    },
    reviewsDetailsTopBlockContainer: {
        display: 'flex',
        width: '100%',
        [`@media (min-width: ${ScreenWidthMinXLarge}px)`]: {
            flexDirection: 'row'
        },
        [`@media (max-width: ${ScreenWidthMinXLarge - 1}px)`]: {
            flexDirection: 'column-reverse'
        }
    },
    reviewsTabTop: {
        paddingTop: 24,
        [`@media (max-width: ${ScreenWidthMinXLarge - 1}px)`]: {
            paddingTop: 0
        }
    },
    reviewsContainer: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    userTermsContainer: {
        backgroundColor: NeutralColors.white,
        border: '1px solid #EAEAEA',
        borderRadius: '2px',
        height: 'fit-content',
        [`@media (max-width: ${ScreenWidthMinXLarge - 1}px)`]: {
            margin: '36 0 24 0'
        },
        [`@media (min-width: ${ScreenWidthMinXLarge - 1}px)`]: {
            marginBottom: 28
        },
        [`@media (min-width: ${ScreenWidthMinXLarge}px) and (max-width: ${ScreenWidthMinXXLarge - 1}px)`]: {
            marginLeft: 40,
            minWidth: 200,
            maxWidth: 200
        },
        [`@media (min-width: ${ScreenWidthMinXXLarge}px)`]: {
            marginLeft: 32,
            minWidth: 256,
            maxWidth: 256
        },
        '& a:link': {
            color: CommunicationColors.primary,
            textDecoration: 'underline'
        },
        '& a:visited': {
            color: CommunicationColors.primary
        },
        '& a:hover': {
            color: CommunicationColors.shade20
        },
        '& a:active': {
            color: CommunicationColors.shade30
        }
    }
});
const consentDisclaimerTokens = {
    padding: 16
};
// Displays a collection of AppReviews
export class AppReviewCollection extends SpzaComponent {
    componentDidMount() {
        const { ensureAppReviewsData, appId, userInfo } = this.props;
        ensureAppReviewsData(appId).then(()=>this.loadReviewsToState(true));
        if (userInfo.signedIn) {
            this.loadReviewIdsMarkedAsHelpful();
            this.loadUserProductReviewMetadata();
        }
    }
    componentDidUpdate(prevProps) {
        const { ensureAppReviewsData, appId } = this.props;
        if (prevProps.reviewsData !== this.props.reviewsData) {
            this.loadReviewsToState(false);
        }
        if (isSignedInChanged(this.props.userInfo.signedIn, prevProps.userInfo.signedIn)) {
            ensureAppReviewsData(appId);
            this.loadReviewIdsMarkedAsHelpful();
            this.loadUserProductReviewMetadata();
        }
        this.scrollToReviewIfNeeded();
    }
    loadReviewIdsMarkedAsHelpful() {
        const { loadReviewIdsMarkedAsHelpful, appId: offerId } = this.props;
        loadReviewIdsMarkedAsHelpful({
            offerId
        });
    }
    loadUserProductReviewMetadata() {
        const { loadUserProductReviewMetadata, appId: legacyId } = this.props;
        loadUserProductReviewMetadata({
            legacyId
        });
    }
    loadReviewsToState(deepLinkMode) {
        const reviews = this.props.reviewsData.reviews;
        // If there are no reviews we get an empty string, we just need to convert it into an array.
        let returnedReviews = [];
        if (reviews && Array.isArray(returnedReviews)) {
            // Filter out any reviews that lack both a title and a description
            returnedReviews = reviews.filter((review)=>review.content || review.title);
        }
        let pagination = createDefaultPagination(returnedReviews);
        let scrollToReview = false;
        // Deep link into review. Select the right page and "trigger" scroll action.
        if (deepLinkMode && this.props.reviewId) {
            pagination = createDeepLinkPagination(reviews, this.props.reviewId);
            scrollToReview = true;
        }
        this.setState({
            reviewList: returnedReviews,
            originalReviewList: returnedReviews,
            currentStart: pagination.startIndex,
            currentEnd: pagination.endIndex,
            currentPageNumber: pagination.pageIndex,
            scrollToReview: scrollToReview
        });
        return pagination;
    }
    renderReviews(start, end, reviewList) {
        const { appId, locale, isEmbed, appData, userInfo, openSignInModal, reviewsData, markedAsHelpful } = this.props;
        const { userReviewIdsMarkedAsHelpful = [] } = markedAsHelpful;
        if (!reviewList) {
            return [
                /*#__PURE__*/ _jsx("div", {
                    className: "reviewsLoadingSpinner",
                    children: /*#__PURE__*/ _jsx(Spinner, {
                        label: this.context.loc('AppDetail_LoadingText', 'Loading...'),
                        ariaLive: "assertive",
                        labelPosition: "left"
                    })
                }, "reviewsLoading")
            ];
        }
        if (reviewList && reviewList.length === 0) {
            return [
                /*#__PURE__*/ _jsx(NoReviewsToShow, {
                    context: this.context,
                    isOfferPurchased: reviewsData.isPurchased,
                    openReviewModal: this.openReviewModal
                }, 0)
            ];
        }
        // This is to handle the last page. If there number of reviews is less than the end of page, then
        // we don't have to loop until end. We can stop at the point when there are no more reviews.
        const listEnd = reviewList.length < end ? reviewList.length : end;
        const appReviewItems = [];
        let i = 0;
        // 'start' begins from 1.
        for(i = start - 1; i < listEnd; i++){
            const review = reviewList[`${i}`];
            appReviewItems.push(/*#__PURE__*/ _jsx(AppReviewItem, {
                reviewItemShown: this.onReviewItemShown,
                appId: appId,
                review: review,
                locale: locale,
                isEmbed: isEmbed,
                publisher: appData ? appData.publisher : '',
                iconUrl: appData ? appData.iconURL : '',
                isSignedIn: userInfo.signedIn,
                isMarkedAsHelpful: userReviewIdsMarkedAsHelpful.includes(review.id),
                onToggleMarkAsHelpful: ({ isHelpful })=>this.toggleMarkAsHelpful({
                        review,
                        isHelpful
                    }),
                openSignInModal: openSignInModal,
                fallbackReviewSourceName: Constants.StorefrontName.AppSource,
                authorPersona: true,
                dateLabelClassName: contentStyles.reviewsDateLabel
            }));
        }
        return appReviewItems;
    }
    toggleMarkAsHelpful(args) {
        const { appId: offerId, toggleMarkAsHelpful } = this.props;
        toggleMarkAsHelpful(_object_spread_props(_object_spread({}, args), {
            offerId
        }));
    }
    getReviewCounterText() {
        var _this_state_currentStart, _this_state_currentEnd, _this_state_reviewList_length;
        if (!this.state.reviewList || this.state.reviewList.length === 0) {
            return null;
        }
        return this.context.locParams('ReviewCollection_ReviewsCounterOfTotal', [
            ((_this_state_currentStart = this.state.currentStart) === null || _this_state_currentStart === void 0 ? void 0 : _this_state_currentStart.toString()) || '',
            ((_this_state_currentEnd = this.state.currentEnd) === null || _this_state_currentEnd === void 0 ? void 0 : _this_state_currentEnd.toString()) || '',
            ((_this_state_reviewList_length = this.state.reviewList.length) === null || _this_state_reviewList_length === void 0 ? void 0 : _this_state_reviewList_length.toString()) || ''
        ], 'Showing {0}-{1} of {2} reviews');
    }
    setCurrentPage(event) {
        var _event_target;
        const idClicked = event === null || event === void 0 ? void 0 : (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.id;
        if (!idClicked) {
            return;
        }
        // This indicates the current page which should be displayed
        let pageNumberClicked = 0;
        if (idClicked === 'previous') {
            pageNumberClicked = this.state.currentPageNumber - 1;
        } else if (idClicked === 'next') {
            pageNumberClicked = this.state.currentPageNumber + 1;
        } else {
            // if it was not prev/next, then we have a page number.
            pageNumberClicked = parseInt(idClicked, 10);
        }
        // Page number * number of items per page gives the total number of items displayed.
        // Since we want the total number of items displayed so far, we do -1.
        const startArrayIndex = (pageNumberClicked - 1) * Constants.MaxItemsPerPageInReviews;
        // startArrayIndex is the total number of items displayed so far. We don't want to display the
        // last item from the prev page. So currentPageStart should be a +1 from that.
        const currentPageStart = startArrayIndex + 1;
        let currentPageEnd = startArrayIndex + Constants.MaxItemsPerPageInReviews;
        // the number of reviews in the last page can be less then 10, in this case currentPageEnd should be the current total number of reviews
        currentPageEnd = currentPageEnd > this.state.reviewList.length ? this.state.reviewList.length : currentPageEnd;
        this.setState((prevState)=>{
            return {
                reviewList: prevState.reviewList,
                currentStart: currentPageStart,
                currentEnd: currentPageEnd,
                currentPageNumber: pageNumberClicked
            };
        });
        const telemetryDetails = {
            currentPageNumber: pageNumberClicked,
            previousPageNumber: this.state.currentPageNumber,
            currentReviewListStart: currentPageStart,
            currentReviewListEnd: currentPageEnd,
            reviewListLength: this.state.reviewList && this.state.reviewList.length || 0
        };
        launchTelemetry(Constants.Telemetry.Action.Click, Constants.Telemetry.ActionModifier.ReviewPageNavigationButton, telemetryDetails);
        logger.info(JSON.stringify(telemetryDetails), {
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.ReviewPageNavigationButton
        });
    }
    getPaginationList() {
        // If the number of reviews is less than the items per page, then pagination div is not necessary.
        if (!this.state.reviewList || this.state.reviewList.length < Constants.MaxItemsPerPageInReviews) {
            return null;
        }
        const reviewListLength = this.state.reviewList.length;
        let numberOfPages = Math.floor(reviewListLength / Constants.MaxItemsPerPageInReviews);
        // The final page has lesser number of items than 'MaxItemsPerPageInReviews'
        // then we'll have a reminder set of reviews which should go into its own page.
        if (reviewListLength % Constants.MaxItemsPerPageInReviews > 0) {
            numberOfPages++;
        }
        let i = 0;
        const pageNumberList = [];
        // Only for pages greater than 1 we would show 'previous'.
        if (this.state.currentPageNumber > 1) {
            pageNumberList.push(/*#__PURE__*/ _jsx("li", {
                children: /*#__PURE__*/ _jsx("a", {
                    href: "#",
                    className: "c-glyph paginationPrevious",
                    "aria-label": "Previous page",
                    // eslint-disable-next-line react/forbid-dom-props
                    id: "previous",
                    onClick: (event)=>this.setCurrentPage(event),
                    children: this.context.loc('PAGINATION_Previous')
                })
            }, "prev"));
        }
        let pageNumberStart = 0;
        let pageNumberEnd = Math.min(numberOfPages, 9);
        if (this.state.currentPageNumber > 4 && numberOfPages >= 9) {
            // if there are more than 9 pages, then we want to show only 9 at a time.
            // 4 (or how many ever exists) after the current one - if exists. Otherwise upto the maximum number of pages.
            pageNumberEnd = Math.min(this.state.currentPageNumber + 4, numberOfPages);
            // pageNumberStart should be 4 pages before the current one.
            // pageNumberStart can never be negative for the following reasons.
            // This condition is executed only if number of pages is greater than 9.
            // Also min value of currentPageNumber > 4 is 5. pageNumberEnd can either be currentPageNumber + 4 (which is 9)
            // or number of pages (which, if it has entered this block is at least 9).
            pageNumberStart = pageNumberEnd - 9;
        }
        for(i = pageNumberStart; i < pageNumberEnd; i++){
            const isActive = this.state.currentPageNumber === i + 1;
            pageNumberList.push(/*#__PURE__*/ _jsx("li", {
                className: isActive ? 'f-active' : null,
                children: /*#__PURE__*/ _jsx("a", {
                    href: "#",
                    "aria-current": isActive,
                    "aria-label": 'Page ' + (i + 1),
                    // eslint-disable-next-line react/forbid-dom-props
                    id: (i + 1).toString(),
                    onClick: (event)=>this.setCurrentPage(event),
                    children: i + 1
                })
            }, i));
        }
        // If we are at the last page we shouldn't show the 'next' button.
        if (this.state.currentPageNumber < numberOfPages) {
            pageNumberList.push(/*#__PURE__*/ _jsx("li", {
                children: /*#__PURE__*/ _jsx("a", {
                    href: "#",
                    className: "c-glyph paginationNext",
                    "aria-label": "Next page",
                    // eslint-disable-next-line react/forbid-dom-props
                    id: "next",
                    onClick: (event)=>this.setCurrentPage(event),
                    children: this.context.loc('PAGINATION_Next')
                })
            }, "next"));
        }
        return /*#__PURE__*/ _jsx("ul", {
            className: "m-pagination",
            children: pageNumberList
        });
    }
    renderReviewsDetailsTopBlock(externalRatingSummaries) {
        const { appData, billingCountryCode } = this.props;
        const internalSummaries = getRatingSummaryByType(appData === null || appData === void 0 ? void 0 : appData.ratingSummaries, Constants.Reviews.ReviewsSource.Internal);
        const textButton = getReviewCtaButtonText(this.context, this.props.reviewsData.userReview);
        return this.props.reviewsData.entityId === this.props.appId && /*#__PURE__*/ _jsx(Stack.Item, {
            className: classNames([
                'reviewTabTop',
                contentStyles.reviewsTabTop
            ]),
            children: /*#__PURE__*/ _jsxs(Stack, {
                className: contentStyles.reviewsDetailsTopBlockContainer,
                children: [
                    /*#__PURE__*/ _jsxs(Stack.Item, {
                        grow: true,
                        className: contentStyles.reviewsContainer,
                        children: [
                            /*#__PURE__*/ _jsx(RatingSummary, {
                                ratingSummary: internalSummaries || (appData === null || appData === void 0 ? void 0 : appData.ratingSummary),
                                context: this.context,
                                title: internalSummaries ? this.context.loc('RatingSummary_Title', 'Marketplace ratings') : this.context.loc('AppDetails_ASRatings', 'AppSource ratings')
                            }),
                            (externalRatingSummaries === null || externalRatingSummaries === void 0 ? void 0 : externalRatingSummaries.length) > 0 && /*#__PURE__*/ _jsx(ExternalRatingSummaries, {
                                externalRatingSummaries: externalRatingSummaries
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "addReview",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "addReviewTitle",
                                        children: this.context.loc('AppReviewCollection_SubHeaderTitle_Text', 'Your review')
                                    }),
                                    /*#__PURE__*/ _jsx(DefaultButton, {
                                        className: "reviewCTA",
                                        text: textButton,
                                        onClick: this.openReviewModal,
                                        "data-bi-id": Constants.JsllCTAId.WriteReview,
                                        "data-bi-area": "Review",
                                        "aria-label": textButton,
                                        disabled: !this.props.reviewsData.isPurchased
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "addReviewDescription",
                                        children: getAddReviewSectionDescription(this.context, this.props.reviewsData.isPurchased)
                                    })
                                ]
                            })
                        ]
                    }),
                    shouldShowUserTerms({
                        app: appData,
                        billingCountryCode
                    }) && /*#__PURE__*/ _jsx(Stack.Item, {
                        tokens: consentDisclaimerTokens,
                        className: contentStyles.userTermsContainer,
                        children: /*#__PURE__*/ _jsx(UserTerms, {
                            app: appData
                        })
                    })
                ]
            })
        });
    }
    renderImpl() {
        var _this_props_appData;
        const externalRatingSummaries = getExternalRatingSummaries((_this_props_appData = this.props.appData) === null || _this_props_appData === void 0 ? void 0 : _this_props_appData.ratingSummaries);
        const updateStateByFilters = {
            updatePaginationState: this.updatePaginationState,
            updateStateByFilters: this.updateStateByFilters,
            updateStateBySortFilter: this.updateStateBySortFilter
        };
        const { userCommentedReviewIds, reviewsData, showMyCommentsFilter } = this.props;
        const { hasInternalReviews, hasExternalReviews } = findReviewsSources(reviewsData);
        return /*#__PURE__*/ _jsxs(Stack, {
            className: "spza_ASappReviewContainer",
            children: [
                this.props.isEmbed ? null : this.renderReviewsDetailsTopBlock(externalRatingSummaries),
                this.props.reviewsData.entityId === this.props.appId && /*#__PURE__*/ _jsxs("div", {
                    className: contentStyles.reviewsTopBar,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "reviewCounter",
                            children: /*#__PURE__*/ _jsx("div", {
                                children: this.getReviewCounterText()
                            })
                        }),
                        /*#__PURE__*/ _jsx(ReviewsDropDowns, {
                            curSourceFilter: this.state.sourceFilter,
                            curSortBy: this.state.sortBy,
                            curRatingFilter: this.state.ratingsFilter,
                            context: this.context,
                            updateReviewsState: updateStateByFilters,
                            originalReviewList: this.state.originalReviewList,
                            curReviewsList: this.state.reviewList,
                            externalReviewsExist: hasExternalReviews,
                            internalReviewsExist: hasInternalReviews,
                            userReview: reviewsData.userReview,
                            userCommentedReviewIds: userCommentedReviewIds,
                            showMyCommentsFilter: showMyCommentsFilter
                        })
                    ]
                }),
                this.renderReviews(this.state.currentStart, this.state.currentEnd, this.state.reviewList),
                /*#__PURE__*/ _jsx("div", {
                    className: "reviewCounter-bottom",
                    children: this.state.reviewList && this.state.reviewList.length >= Constants.MaxItemsPerPageInReviews ? this.getReviewCounterText() : null
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "reviewPagination",
                    children: this.getPaginationList()
                }, this.state.currentPageNumber)
            ]
        });
    }
    constructor(props, state){
        super(props), _define_property(this, "context", void 0), _define_property(this, "onReviewItemShown", (reviewId, reviewCompRef)=>{
            if (this.props.reviewId && reviewCompRef && this.props.reviewId === reviewId) {
                this.setState({
                    scrollToReviewItemRef: reviewCompRef
                });
            }
        }), _define_property(this, "scrollToReviewIfNeeded", ()=>{
            if (this.state.scrollToReview && this.state.scrollToReviewItemRef && this.props.reviewId && this.state.scrollToReviewItemRef.current) {
                const elementPosition = this.state.scrollToReviewItemRef.current.getBoundingClientRect().top;
                const offsetPosition = elementPosition - this.getReviewsScrollOffset();
                getWindow().scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
                this.setState({
                    scrollToReview: false
                });
            }
        }), _define_property(this, "getReviewsScrollOffset", ()=>{
            const stickyCardHeight = this.context.getAppDetailsStickyCardHeight();
            const mainMenuHeight = this.context.getAppHeaderHeight();
            const headerOffset = (stickyCardHeight || DEFAULT_STICKY_HEIGHT) + (mainMenuHeight || DEFAULT_MENU_HEIGHT) + SCROLL_TO_REVIEW_TOP_MARGIN;
            return headerOffset;
        }), _define_property(this, "openReviewModal", ()=>{
            var _this_props_location_query, _this_props_location;
            let ctaType = null;
            if ((_this_props_location = this.props.location) === null || _this_props_location === void 0 ? void 0 : (_this_props_location_query = _this_props_location.query) === null || _this_props_location_query === void 0 ? void 0 : _this_props_location_query.ctatype) {
                ctaType = this.props.location.query.ctatype;
            }
            launchTelemetry(Constants.Telemetry.Action.Click, Constants.Telemetry.ActionModifier.OpenRatingModalFromReviewTab, {
                appId: this.props.appId
            });
            logger.info(JSON.stringify({
                appId: this.props.appId
            }), {
                action: Constants.Telemetry.Action.Click,
                actionModifier: Constants.Telemetry.ActionModifier.OpenRatingModalFromReviewTab
            });
            this.props.openRatingModal(this.props.appData, null, ctaType, ()=>{
                launchTelemetry(Constants.Telemetry.Action.Open, Constants.Telemetry.ActionModifier.OpenRatingModalFromReviewTab, {
                    appId: this.props.appId
                });
                logger.info(JSON.stringify({
                    appId: this.props.appId
                }), {
                    action: Constants.Telemetry.Action.Open,
                    actionModifier: Constants.Telemetry.ActionModifier.OpenRatingModalFromReviewTab
                });
                this.clearFiltersByState();
            });
        }), _define_property(this, "updatePaginationState", (curPageNumber, curStart, currentEnd)=>{
            this.setState({
                currentPageNumber: curPageNumber,
                currentStart: curStart,
                currentEnd: currentEnd
            });
        }), _define_property(this, "updateStateByFilters", (updatedRatingsFilter, updatedReviewList, updatedSourceFilter)=>{
            this.setState({
                ratingsFilter: updatedRatingsFilter,
                reviewList: updatedReviewList,
                sourceFilter: updatedSourceFilter
            });
        }), _define_property(this, "clearFiltersByState", ()=>{
            this.setState({
                sourceFilter: null,
                ratingsFilter: null,
                sortBy: null
            });
        }), _define_property(this, "updateStateBySortFilter", (updatedSortBy)=>{
            this.setState({
                sortBy: updatedSortBy
            });
        });
        this.state = state || {
            currentStart: 1,
            currentEnd: 1,
            currentPageNumber: 1,
            scrollToReview: false,
            scrollToReviewItemRef: null
        };
    }
}
AppReviewCollection.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    getAppDetailsStickyCardHeight: PropTypes.func,
    getAppHeaderHeight: PropTypes.func
};
